import Vue from 'vue/dist/vue.esm';
import StartBox from './components/StartBox';
import 'whatwg-fetch';

// From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
Number.isNaN =
    Number.isNaN ||
    function(value) {
        return value !== value;
    };

Vue.config.productionTip = false;

new Vue({
    render: h => h(StartBox),
}).$mount('#startBox');
